<template>
  <v-app>
    <v-main v-if="(page_type == 'requireAuth') || (page_type == 'onlyMain')">
      <Layout2 :page_type=page_type></Layout2>
    </v-main>

    <v-main v-else>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>


<script>
import Layout2 from '@/components/Layout2.vue'

export default {
  name: 'App',

  components: {
    Layout2,
  },
  data() {
    return {
      page_type: '',
    }
  },
  watch: {
    $route(to, from) {
      this.page_type = to.meta.pageType
    }
  },
}
</script>
